import "./index.scss";

import { Box, Stack } from "@mui/material";
import SearchBar from "components/SearchBar";
import TitleWithOptions from "components/TitleWithOptions";
import { WorkoutPlan } from "models/workoutplan";
import HoverVideoPlayer from "react-hover-video-player";

const FlexibilityProgramSection = (props: {
  from?: string;
  workoutPlan: WorkoutPlan;
  upperBodyStretchesOptions: any[];
  lowerBodyStretchesOptions: any[];
}) => {
  const { from, workoutPlan, upperBodyStretchesOptions, lowerBodyStretchesOptions } = props;
  const upperBodyStretches =
    upperBodyStretchesOptions?.filter((f) => workoutPlan?.stretch_exercises?.includes(f.id)) || [];
  const lowerBodyStretches =
    lowerBodyStretchesOptions?.filter((f) => workoutPlan?.stretch_exercises?.includes(f.id)) || [];

  return (
    <section className="flexibility-program-section">
      <TitleWithOptions title="Flexibility Program" />
      <Box className="inner-section">
        <Box flex={1} className="tutorial-container">
          <p className="tutorial-container-title">Upper Body Stretches</p>
          <Box className="tutorial-list">
            <Stack direction="row" sx={{ borderBottom: 1, borderColor: "#D6EEEC" }}>
              <SearchBar value={""} onSearch={() => {}} />
            </Stack>
            <Box className={`items ${from}`}>
              {upperBodyStretches?.map((e, i) => (
                <TutorialItem
                  key={`upperStretch${i}`}
                  title={e.title}
                  instructions={e.instructions}
                  video={e.video}
                />
              ))}
            </Box>
          </Box>
        </Box>
        <Box flex={1} className="tutorial-container">
          <p className="tutorial-container-title">Lower Body Stretches</p>
          <Box className="tutorial-list">
            <Stack direction="row" sx={{ borderBottom: 1, borderColor: "#D6EEEC" }}>
              <SearchBar value={""} onSearch={() => {}} />
            </Stack>
            <Box className={`items ${from}`}>
              {lowerBodyStretches?.map((e, i) => (
                <TutorialItem
                  key={`lowerStretch${i}`}
                  title={e.title}
                  instructions={e.instructions}
                  video={e.video}
                />
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </section>
  );
};

const TutorialItem = (props: { title: string; instructions: string; video: string }) => {
  const { title, instructions, video } = props;

  return (
    <Box className="item">
      <Box className="video" sx={{ flexShrink: 0, width: "191px" }}>
        <HoverVideoPlayer
          videoSrc={video}
          restartOnPaused
          loadingOverlay={
            <div className="loading-overlay">
              <div className="loading-spinner" />
            </div>
          }
        />
      </Box>
      <Box className="contents">
        <p className="section-title">{title}</p>
        <p className="description">{instructions}</p>
      </Box>
    </Box>
  );
};

export default FlexibilityProgramSection;
